import * as errors from "../errors.js";
import { state } from "../state.js";

/*
    The function LEN returns the number of characters in a string. This value is in the range 0 to 255.
    If the argument does not result into a string value the BASIC error ?TYPE MISMATCH ERROR appears.
    If the parameter expression evaluates to a string with more than 255 characters the BASIC error ?STRING TOO LONG occurs. 
    It is to be noted that this is not part of the LEN function itself. Any given string can not exceed a length of 255 characters.
    In the absence of any numeric argument or with more than one parameter results in a ?SYNTAX ERROR. 
*/
export const len = async (args) => {
    // If no args are given, throw a syntax error.
    if (!args || args.length === 0) {
        throw new errors.SyntaxError();
    }

    // Check if the args is a string.
    if (typeof args !== "string") {
        throw new errors.TypeMismatchError();
    }

    // Check if the string is not too long.
    if (args.length > state.maxStringLength) {
        throw new errors.StringTooLongError();
    }

    // Return the length of the string.
    return args.length;
};